var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"postSaleBody clearfix"},[_c('div',[_c('img',{attrs:{"src":require("../assets/imgs/post_sale_suuccess.png"),"alt":""}})]),_c('p',[_vm._v("提交成功"),_c('br'),_vm._v("可在IPTV端查看退款进度")])])
}]

export { render, staticRenderFns }